import React, { useEffect } from "react";
import PaymentView from "../../../templates/payment-view";
import PackagesView, {
  PRICING_DISPLAY_VARIANTS,
} from "../../../templates/payment-package-view";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPackageId } from "../../../store/actions/pay-for-ad";
import CheckoutView from "./checkout-view";
import PaymentError from "./checkout-view/templates/payment-error";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PAYMENT_TYPES } from "../../../config/constant";

const PaymentContainerLk = ({ setPricingVersion, displayNewPayment }) => {
  const { selectedPackageId, checkoutError, renewalError } = useSelector(
    (state) => state.payForAd
  );

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const recurringPayment = sessionStorage.getItem(PAYMENT_TYPES.IS_RECURRING);

  useEffect(() => {
    if (recurringPayment === null) {
      history.push("/pay-for-ad");
      dispatch(setSelectedPackageId(undefined));
      return;
    }

    const query = new URLSearchParams(location.search);
    const param = query.get("id");
    if (param !== null) {
      dispatch(setSelectedPackageId(param));
    } else {
      dispatch(setSelectedPackageId(undefined));
    }
  }, [location, dispatch, history, recurringPayment]);

  return (
    <PaymentView
      setPricingVersion={setPricingVersion}
      displayNewPayment={displayNewPayment}
    >
      {checkoutError || renewalError ? (
        <PaymentError />
      ) : (
        <>
          {!selectedPackageId && (
            <PackagesView variant={PRICING_DISPLAY_VARIANTS.PAY_FOR_AD} />
          )}
          {selectedPackageId && <CheckoutView />}
        </>
      )}
    </PaymentView>
  );
};

export default PaymentContainerLk;
